/* ============================================================
   Duvet Nomade — Comparateur de sacs de couchage
   Fichier : assets/dn-comparateur.js
============================================================ */

(function () {
  'use strict';

  var p1 = null;
  var p2 = null;
  var allProducts = [];

  function formatTemp(val) {
    if (!val) return val;
    var n = parseFloat(String(val).replace(',', '.'));
    if (isNaN(n)) return val;
    return n % 1 === 0 ? String(Math.round(n)) : String(val).replace('.', ',');
  }

  function init() {
    var dataEl = document.getElementById('dnCmpP1Data');
    var listEl = document.getElementById('dnCmpProductsData');
    if (!dataEl || !listEl) return;

    try {
      p1 = JSON.parse(dataEl.textContent);
      allProducts = JSON.parse(listEl.textContent);
    } catch (e) {
      console.warn('[DN Comparateur] Erreur parsing JSON :', e);
      return;
    }

    // Fermer avec Echap
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (document.getElementById('dnCmpPicker').classList.contains('open')) {
          dnCmpClosePicker();
        } else if (document.getElementById('dnCmpDrawer').classList.contains('open')) {
          dnCmpClose();
        }
      }
    });
  }

  /* ── Drawer ── */
  window.dnCmpOpen = function () {
    var scrollbarW = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.paddingRight = scrollbarW + 'px';
    document.body.style.overflow = 'hidden';
    document.getElementById('dnCmpOverlay').classList.add('open');
    document.getElementById('dnCmpDrawer').classList.add('open');
  };

  window.dnCmpClose = function () {
    document.getElementById('dnCmpOverlay').classList.remove('open');
    document.getElementById('dnCmpDrawer').classList.remove('open');
    if (!document.getElementById('dnCmpPicker').classList.contains('open')) {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }
  };

  /* ── Picker ── */
  window.dnCmpOpenPicker = function () {
    renderPickerList('');
    document.getElementById('dnCmpDrawer').classList.remove('open');
    document.getElementById('dnCmpPicker').classList.add('open');
    var input = document.getElementById('dnCmpSearch');
    if (input) { input.value = ''; setTimeout(function() { input.focus(); }, 100); }
  };

  window.dnCmpClosePicker = function () {
    document.getElementById('dnCmpPicker').classList.remove('open');
    document.getElementById('dnCmpDrawer').classList.add('open');
  };

  window.dnCmpFilter = function (query) {
    renderPickerList(query.toLowerCase().trim());
  };

  function renderPickerList(query) {
    var list = document.getElementById('dnCmpPickerList');
    if (!list) return;
    list.innerHTML = '';

    var hasResults = false;

    allProducts.forEach(function (group) {
      // Filtrer les produits du groupe
      var filtered = group.products.filter(function (p) {
        if (!query) return true;
        return (p.title && p.title.toLowerCase().includes(query)) ||
               (p.vendor && p.vendor.toLowerCase().includes(query));
      });

      if (filtered.length === 0) return;
      hasResults = true;

      // Titre de collection
      var groupEl = document.createElement('div');
      groupEl.className = 'dn-cmp-picker-group';
      groupEl.innerHTML = '<div class="dn-cmp-picker-group__title">' + escHtml(group.collection) + '</div>';
      list.appendChild(groupEl);

      // Produits du groupe
      filtered.forEach(function (p) {
        var el = document.createElement('div');
        el.className = 'dn-cmp-picker-item';
        el.setAttribute('role', 'button');
        el.setAttribute('tabindex', '0');
        el.setAttribute('aria-label', 'Comparer avec ' + p.title);

        var imgHtml = p.image
          ? '<img class="dn-cmp-picker-item__img" src="' + p.image + '" alt="' + escHtml(p.image_alt || p.title) + '" width="48" height="48" loading="lazy">'
          : '<div class="dn-cmp-picker-item__img dn-cmp-picker-item__img--empty"></div>';

        var meta = '';
        if (p.temp_confort) meta += 'Confort ' + formatTemp(p.temp_confort) + '°C';
        if (p.poids) meta += (meta ? ' · ' : '') + p.poids + ' g';

        var isSelected = p2 && p2.id === p.id;

        el.innerHTML = imgHtml +
          '<div style="flex:1;">' +
            '<div class="dn-cmp-picker-item__name">' + escHtml(p.title) + '</div>' +
            (meta ? '<div class="dn-cmp-picker-item__meta">' + escHtml(meta) + '</div>' : '') +
          '</div>' +
          '<svg class="dn-cmp-picker-item__check' + (isSelected ? ' visible' : '') + '" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';

        el.addEventListener('click', function () { selectP2(p); });
        el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') selectP2(p); });
        list.appendChild(el);
      });
    });

    if (!hasResults) {
      list.innerHTML = '<p style="padding:20px 0;color:#6B7280;font-size:1.3rem;text-align:center;">Aucun résultat</p>';
    }
  }

  function selectP2(p) {
    p2 = p;
    dnCmpClosePicker();
    renderSel2();
    renderComparison();
  }

  function renderSel2() {
    var c = document.getElementById('dnCmpSel2');
    if (!c) return;
    var imgHtml = p2.image
      ? '<img class="dn-cmp-sel-img" src="' + p2.image + '" alt="' + escHtml(p2.image_alt || p2.title) + '" width="40" height="40" loading="lazy">'
      : '<div class="dn-cmp-sel-img dn-cmp-sel-img--empty"></div>';
    c.innerHTML =
      '<div class="dn-cmp-sel-card">' +
        imgHtml +
        '<div class="dn-cmp-sel-info">' +
          '<div class="dn-cmp-sel-name">' + escHtml(p2.title) + '</div>' +
        '</div>' +
        '<button class="dn-cmp-sel-change" onclick="dnCmpOpenPicker()">Changer</button>' +
      '</div>';
  }

  /* ── Rendu comparaison ── */
  function renderComparison() {
    if (!p1 || !p2) return;
    var body = document.getElementById('dnCmpBody');
    if (!body) return;

    body.innerHTML =
      section('Thermique', tempRow(p1, p2)) +
      section('Poids & encombrement',
        row('Poids', val(p1.poids, 'g'), val(p2.poids, 'g'), true) +
        row('Volume compressé', p1.volume_compresse, p2.volume_compresse, true) +
        row('Dimensions', p1.dimensions, p2.dimensions, false)
      ) +
      section('Garnissage & certification',
        row('Garnissage', p1.garnissage, p2.garnissage, false) +
        row('Pouvoir gonflant', val(p1.cuin, 'cuin'), val(p2.cuin, 'cuin'), false) +
        row('Norme thermique', p1.norme_thermique, p2.norme_thermique, false)
      ) +
      section('Matériaux',
        row('Tissu extérieur', p1.tissu_ext, p2.tissu_ext, false) +
        row('Tissu intérieur', p1.tissu_int, p2.tissu_int, false)
      ) +
      section('Usage',
        row('Saison', p1.saison, p2.saison, false) +
        row('Forme', p1.forme, p2.forme, false) +
        row("Type d'usage", p1.type_usage, p2.type_usage, false)
      );

    var footer = document.getElementById('dnCmpFooter');
    var cta2 = document.getElementById('dnCmpCta2');
    if (footer) footer.style.display = 'grid';
    if (cta2) {
      cta2.textContent = 'Voir ' + p2.title + ' →';
      cta2.href = p2.url;
    }
  }

  function val(v, unit) {
    if (!v) return null;
    return v + (unit ? ' ' + unit : '');
  }

  function section(title, rows) {
    return '<div class="dn-cmp-section"><div class="dn-cmp-section__title">' + title + '</div>' + rows + '</div>';
  }

  function tempRow(a, b) {
    if (!a.temp_confort && !a.temp_limit && !a.temp_extreme && !b.temp_confort && !b.temp_limit && !b.temp_extreme) return '';
    return '<div class="dn-cmp-row">' +
      '<div class="dn-cmp-cell">' +
        '<span class="dn-cmp-cell__label">Plage thermique</span>' +
        '<div class="dn-cmp-temps">' +
          (a.temp_confort ? '<span class="dn-cmp-temp-pill dn-cmp-temp-pill--confort">Confort ' + formatTemp(a.temp_confort) + '°C</span>' : '') +
          (a.temp_limit   ? '<span class="dn-cmp-temp-pill dn-cmp-temp-pill--limite">Limite ' + formatTemp(a.temp_limit) + '°C</span>' : '') +
          (a.temp_extreme ? '<span class="dn-cmp-temp-pill dn-cmp-temp-pill--extreme">Extrême ' + formatTemp(a.temp_extreme) + '°C</span>' : '') +
        '</div>' +
      '</div>' +
      '<div class="dn-cmp-cell">' +
        '<span class="dn-cmp-cell__label">Plage thermique</span>' +
        '<div class="dn-cmp-temps">' +
          (b.temp_confort ? '<span class="dn-cmp-temp-pill dn-cmp-temp-pill--confort">Confort ' + formatTemp(b.temp_confort) + '°C</span>' : '') +
          (b.temp_limit   ? '<span class="dn-cmp-temp-pill dn-cmp-temp-pill--limite">Limite ' + formatTemp(b.temp_limit) + '°C</span>' : '') +
          (b.temp_extreme ? '<span class="dn-cmp-temp-pill dn-cmp-temp-pill--extreme">Extrême ' + formatTemp(b.temp_extreme) + '°C</span>' : '') +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function row(label, v1, v2, lowerIsBetter) {
    // Si les deux valeurs sont absentes, on n'affiche pas la ligne
    if (!v1 && !v2) return '';
    var classes = winClasses(v1, v2, lowerIsBetter);
    var em = '<span class="dn-cmp-cell__empty">—</span>';
    var rowEmojis = {
      'Poids': '⚖️', 'Volume compressé': '🎒', 'Dimensions': '📐',
      'Garnissage': '🪶', 'Pouvoir gonflant': '💨', 'Norme thermique': '🛡️',
      'Tissu extérieur': '🧵', 'Tissu intérieur': '🧶',
      'Saison': '🗓️', 'Forme': '🏕️', "Type d'usage": '🏔️'
    };
    var rowEmoji = rowEmojis[label] ? '<span class="dn-cmp-cell__emoji">' + rowEmojis[label] + '</span>' : '';
    return '<div class="dn-cmp-row">' +
      '<div class="dn-cmp-cell">' +
        '<span class="dn-cmp-cell__label">' + rowEmoji + label + '</span>' +
        '<span class="dn-cmp-cell__val ' + classes[0] + '">' + (v1 ? escHtml(v1) : em) + '</span>' +
      '</div>' +
      '<div class="dn-cmp-cell">' +
        '<span class="dn-cmp-cell__label">' + rowEmoji + label + '</span>' +
        '<span class="dn-cmp-cell__val ' + classes[1] + '">' + (v2 ? escHtml(v2) : em) + '</span>' +
      '</div>' +
    '</div>';
  }

  function winClasses(v1, v2, lowerIsBetter) {
    return ['', ''];
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();